// extracted by mini-css-extract-plugin
export default {"input-suffix":"input-suffix___VL5mf","form-wrapper":"form-wrapper___WEgtO","text-area":"text-area___uHHSU","text-count":"text-count___BEY_Y"};